import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';
import { WksMistralOcrService } from '../services/wks-mistral-ocr.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../services/user.service";
import * as i3 from "./wks-mistral-ocr.service";
export class WksGedDocumentService {
    constructor(httpClient, _userService, _mistralOCRService) {
        this.httpClient = httpClient;
        this._userService = _userService;
        this._mistralOCRService = _mistralOCRService;
        this.httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json'
        });
    }
    /**
     * Récupération de tous les documents GED
     * d'une entité.
     */
    getDocuments(stdEntity) {
        const url = `${environment.baseUrl}/wks/ged/documents`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        return this.httpClient.post(url, null, {
            headers: headers
        }).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération des documents GED
     * par statut de traitement.
     */
    getDocumentsByProcessingStatus(stdEntity, processingStatus, documentType) {
        const url = `${environment.baseUrl}/wks/ged/documents/status`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        const body = {
            processingStatus: processingStatus,
            documentType: documentType
        };
        return this.httpClient.post(url, body, {
            headers: headers
        }).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Récupération d'un document GED.
     */
    getDocument(stdEntity, id) {
        const url = `${environment.baseUrl}/wks/ged/document`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        const body = {
            id: id
        };
        return this.httpClient.post(url, body, {
            headers: headers
        }).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Création d'un document GED.
     */
    createDocument(stdEntity, document) {
        const url = `${environment.baseUrl}/wks/ged/document/create`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        return this.httpClient.post(url, document, {
            headers: headers
        }).pipe(catchError(this.handleErrorObservable));
    }
    /**
     * Mise à jour d'un document GED.
     */
    updateDocument(stdEntity, document) {
        const url = `${environment.baseUrl}/wks/ged/document/update`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        return this.httpClient.post(url, document, {
            headers: headers
        }).pipe(catchError(this.handleErrorObservable));
    }
    cancelGedDocuments(documents) {
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        return this.httpClient.post(`${environment.baseUrl}/wks/ged/documents/cancel`, documents, {
            headers: headers
        });
    }
    /**
     * Désactivation logique d'un document GED.
     */
    disableDocument(stdEntity, id) {
        const url = `${environment.baseUrl}/wks/ged/document/disable`;
        const headers = this.httpHeaders.set('stdEntity', stdEntity);
        const body = {
            id: id
        };
        return this.httpClient.post(url, body, {
            headers: headers,
            observe: 'response'
        }).pipe(catchError(this.handleErrorObservable));
    }
    getDocumentContent(document) {
        const url = `${environment.baseUrl}/wks/ged/document/content`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        return this.httpClient.post(url, document, {
            headers: headers,
            responseType: 'blob'
        }).pipe(catchError(this.handleErrorObservable));
    }
    getDocumentOcr(document) {
        const url = `${environment.baseUrl}/wks/ged/document/ocr`;
        let headers = this._userService.getHeaders();
        headers = headers.set('stdEntity', this._userService.getUserLogged().entity);
        return this.httpClient.post(url, document, {
            headers: headers,
            responseType: 'text'
        }).pipe(catchError(this.handleErrorObservable));
    }
    handleErrorObservable(error) {
        throw error;
    }
}
WksGedDocumentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WksGedDocumentService_Factory() { return new WksGedDocumentService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UserService), i0.ɵɵinject(i3.WksMistralOcrService)); }, token: WksGedDocumentService, providedIn: "root" });
